interface DevStationListType {
  [key: string]: {
    id: string;
  }
}

const DEV_STATIONS_LIST: DevStationListType = {
  'koth.localhost': {
    id: 'f3842586-2c40-43fa-a79f-841fd5f2b9cb'
  },
  'koth.svp.edcar.pbs.org': {
    id: 'f3842586-2c40-43fa-a79f-841fd5f2b9cb'
  },
  'koth.svp.beta.pbs.org': {
    id: 'f3842586-2c40-43fa-a79f-841fd5f2b9cb'
  },
  'koth.svp.staging.pbs.org': {
    id: 'f3842586-2c40-43fa-a79f-841fd5f2b9cb'
  },
  'koth.svp.preprod.pbs.org': {
    id: 'f3842586-2c40-43fa-a79f-841fd5f2b9cb'
  },
  'watch.weta.localhost' : {
    id: '92d89794-5ff0-4fe6-a443-cc888104e021'
  },
  'weta.svp.edcar.pbs.org' : {
    id: '92d89794-5ff0-4fe6-a443-cc888104e021'
  },
  'weta.svp.beta.pbs.org' : {
    id: '92d89794-5ff0-4fe6-a443-cc888104e021'
  },
  'weta.svp.staging.pbs.org' : {
    id: '92d89794-5ff0-4fe6-a443-cc888104e021'
  },
  'weta.svp.preprod.pbs.org' : {
    id: '92d89794-5ff0-4fe6-a443-cc888104e021'
  },
  'video.whut.localhost' : {
    id: '722b847a-5e2a-4d14-9429-2d430b10b1ee'
  },
  'whut.svp.edcar.pbs.org' : {
    id: '722b847a-5e2a-4d14-9429-2d430b10b1ee'
  },
  'whut.svp.beta.pbs.org' : {
    id: '722b847a-5e2a-4d14-9429-2d430b10b1ee'
  },
  'whut.svp.staging.pbs.org' : {
    id: '722b847a-5e2a-4d14-9429-2d430b10b1ee'
  },
  'whut.svp.preprod.pbs.org' : {
    id: '722b847a-5e2a-4d14-9429-2d430b10b1ee'
  },
  // MPT's short common name (MPT) is not its callsign (WMPB), unlike our other
  // dev SVPs. Keep it in the list so attribute mix-ups surface locally. RWEB-9977
  'video.mpt.localhost' : {
    id: 'fdb26654-eed0-4858-aa50-a84b538f4747'
  },
  'mpt.svp.edcar.pbs.org' : {
    id: 'fdb26654-eed0-4858-aa50-a84b538f4747'
  },
  'mpt.svp.beta.pbs.org' : {
    id: 'fdb26654-eed0-4858-aa50-a84b538f4747'
  },
  'mpt.svp.staging.pbs.org' : {
    id: 'fdb26654-eed0-4858-aa50-a84b538f4747'
  },
  'mpt.svp.preprod.pbs.org' : {
    id: 'fdb26654-eed0-4858-aa50-a84b538f4747'
  }
}

export function isDevStation(hostname: string) {
  return DEV_STATIONS_LIST[hostname] != undefined
}

export function devStationId(hostname: string) {
  return DEV_STATIONS_LIST[hostname].id
}
